import {
  types,
  // getParent
} from 'mobx-state-tree';

const MiniDashboard = types.model('MiniDashboard', {
  mySubscription: types.optional(types.number, 0),
  listings: types.optional(types.number, 0),
  orders: types.optional(types.number, 0),
  dailyProfit: types.optional(types.number, 0),
  sales: types.optional(types.number, 0),
  balance: types.optional(types.number, 0),
  globalSanityCheckStatusColor: types.optional(types.string, ''),
  globalSanityCheckStatusType: types.optional(types.number, 0),
})
//   .views(self => ({
// }))

export default MiniDashboard;
